import { Link } from 'react-router-dom';
import SafeImage from '../../components/SafeImage';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import JourneyStoryEntry from './JourneyStoryEntry';

export default function JourneyDiscoveryCard({ item, dedicated = false }) {
  const { t, tf, tp } = useTravelTranslation();
  const href = `/public/journeys/${item.publicationId}${dedicated ? '?view=overview' : ''}`;

  return (
    <article className="journey-discovery-card" data-testid={`journey-discovery-card-${item.publicationId}`}>
      <Link to={href} className="journey-discovery-card__cover-link" aria-label={item.title} tabIndex={-1}>
        <SafeImage
          src={item.coverUrl}
          alt=""
          className="journey-discovery-card__cover"
          loading="lazy"
          fallback={<div className="journey-discovery-card__cover journey-discovery-card__cover--fallback" aria-hidden="true" />}
        />
      </Link>
      {dedicated ? (
        <div className="journey-discovery-card__body journey-discovery-card__body--dedicated">
          <div className="journey-discovery-card__meta">
            {item.destinationLabel ? <span>{item.destinationLabel}</span> : null}
            {item.dayCount != null ? <span>{item.dayCount} {t('travel.discover.days')}</span> : null}
          </div>
          <Link to={href} className="journey-discovery-card__title-link"><h3 className="journey-discovery-card__title">{item.title}</h3></Link>
          {item.summary ? <p className="journey-discovery-card__summary">{item.summary}</p> : null}
          {item.storyCardCount > 0 ? <p className="journey-discovery-card__story-status">{tp('travel.discover.story.count', item.storyCardCount)}</p> : null}
          {item.storyKnownEmpty ? <p className="journey-discovery-card__story-status">{t('travel.journeyDiscovery.noStory')}</p> : null}
          <div className="journey-discovery-card__engagement">
            {item.likeCount != null ? <span>{tf('travel.journeyDiscovery.likeCount', { count: item.likeCount })}</span> : null}
            {item.commentCount != null ? <span>{tf('travel.journeyDiscovery.commentCount', { count: item.commentCount })}</span> : null}
            {item.organicCopyCount != null ? <span>{tf('travel.journeyDiscovery.copyCount', { count: item.organicCopyCount })}</span> : null}
          </div>
          <div className="journey-discovery-card__actions">
            <Link to={href} className="journey-discovery-card__cta">{t('travel.discover.viewJourney')}</Link>
            <JourneyStoryEntry compact publicationId={item.publicationId} title={item.title} storyCardCount={item.storyCardCount} />
          </div>
        </div>
      ) : (
      <div className="journey-discovery-card__body">
        <Link to={href} className="journey-discovery-card__title-link">
          <h3 className="journey-discovery-card__title">{item.title}</h3>
        </Link>
        {item.summary ? <p className="journey-discovery-card__summary">{item.summary}</p> : null}
        <div className="journey-discovery-card__meta">
          {item.destinationLabel ? (
            <span className="journey-discovery-card__destination" title={item.destinationLabel}>
              {item.destinationLabel}
            </span>
          ) : null}
          {item.dayCount != null ? (
            <span className="journey-discovery-card__days">
              {item.dayCount} {t('travel.discover.days')}
            </span>
          ) : null}
          {item.budgetLabel ? (
            <span className="journey-discovery-card__budget">{item.budgetLabel}</span>
          ) : null}
        </div>
        <JourneyStoryEntry
          publicationId={item.publicationId}
          title={item.title}
          storyCardCount={item.storyCardCount}
        />
        <Link to={href} className="journey-discovery-card__cta">
          {t('travel.discover.viewJourney')}
        </Link>
      </div>
      )}
    </article>
  );
}
